/**
 * Rocksoft.Apple.Sync
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const SyncType = {
    Applications: 'Applications',
    NotificationProfiles: 'NotificationProfiles',
    WifiProfiles: 'WifiProfiles',
    EraApplicationConfiguration: 'EraApplicationConfiguration',
    AppLockProfile: 'AppLockProfile',
    RestrictionsProfiles: 'RestrictionsProfiles',
    DeviceName: 'DeviceName',
    AirplaySecurityProfile: 'AirplaySecurityProfile',
    ConfigurationProfiles: 'ConfigurationProfiles',
} as const;
export type SyncType = typeof SyncType[keyof typeof SyncType];

